import { StatusTypes, UserTypes } from 'types/GlobalTypes';

import { TypeColorsDictionary, UserDiagnosticsStateColorsDictionary, UserDiagnosticsTagColorsDictionary } from './Constants';
import { UserDiagnosticsState, UserDiagnosticsTag } from 'types/models/UserDiagnosticsModel';

/**
 * @param type: type
 * @returns 'color
 */

export const getColor = (type: UserTypes | StatusTypes | null) => TypeColorsDictionary[type?.toLowerCase() || 'Other'];
export const getUserDiagnoticsStateColor = (state: UserDiagnosticsState) => UserDiagnosticsStateColorsDictionary[state];
export const getUserDiagnoticsTagColor = (state: UserDiagnosticsTag) => UserDiagnosticsTagColorsDictionary[state];

// =================

export const downloadFile = (blob: Blob, filename: string): boolean => {
  const link = document.createElement("a");
  if (link.download !== undefined) {
    let url = URL.createObjectURL(blob);
    
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  }

  return false;
}